import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesSysadminPrecificacao: Routes = [
  {
    path: 'servicos_precificacao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'PRECIFICACAO',
      breadcrumb: {
        label: 'Serviços',
        icon: 'pi pi-fw pi-wrench'
      },
      module: 'SERVICO_PRECIFICACAO',
      backend_path: '/servico_viggos'
    },
    loadChildren: () =>
      import(
        '@app/modules/precificacao/servico_precificacao/servico_precificacao.module'
      ).then(m => m.ServicoPrecificacaoModule)
  },
  {
    path: 'produtos_precificacao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'PRECIFICACAO',
      breadcrumb: {
        label: 'Produtos',
        icon: 'pi pi-fw pi-box'
      },
      module: 'PRODUTO_PRECIFICACAO',
      backend_path: '/produto_viggos'
    },
    loadChildren: () =>
      import(
        '@app/modules/precificacao/produto_precificacao/produtos_precificacao.module'
      ).then(m => m.ProdutoPrecificacaoModule)
  },
  {
    path: 'termos_precificacao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'PRECIFICACAO',
      breadcrumb: {
        label: 'Termos',
        icon: 'pi pi-fw pi-file-check'
      },
      module: 'TERMO_PRECIFICACAO',
      backend_path: '/termo_aceite_viggos'
    },
    loadChildren: () =>
      import(
        '@app/modules/precificacao/termos_precificacao/termos_precificacao.module'
      ).then(m => m.TermosPrecificacaoModule)
  },
  {
    path: 'planos_precificacao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'PRECIFICACAO',
      breadcrumb: {
        label: 'Planos',
        icon: 'mdi mdi-file-plus-outline'
      },
      module: 'PLANO_PRECIFICACAO',
      backend_path: '/plano_viggos'
    },
    loadChildren: () =>
      import(
        '@app/modules/precificacao/plano_precificacao/plano_precificacao.module'
      ).then(m => m.PlanoPrecificacaoModule)
  },
  {
    path: 'contratos_precificacao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'PRECIFICACAO',
      breadcrumb: {
        label: 'Contratos',
        icon: 'mdi mdi-handshake-outline'
      },
      module: 'CONTRATO_PRECIFICACAO',
      backend_path: '/contrato_viggos'
    },
    loadChildren: () =>
      import(
        '@app/modules/precificacao/contrato_precificacao/contrato_precificacao.module'
      ).then(m => m.ContratoPrecificacaoModule)
  }
];
